"use strict";

import Alert from "../Alert";

export default class FileRemove {
  constructor($element) {
    this.$container = $element;
    this.$fileRemoveBtn = this.$container.querySelector('.file-remove-button');
    this.$imagePreviewContainer = this.$container.querySelector('.image-preview-container');

    this.listen();
  }

  listen() {
    if (this.$fileRemoveBtn) {
      this.listenFileRemove();
    }
  }

  listenFileRemove() {
    this.$fileRemoveBtn.addEventListener('click', () => {
      this.handleFileRemove();
    });
  }

  /**
   * Removes a file from the server and the DOM if the client confirms the file removal.
   *
   * @note The API endpoint requires the model name, model ID, and file type to correctly identify and remove the specified file.
   * @returns {void}
   */
  handleFileRemove() {
    const confirmationMessage = document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr'
      ? 'Attention : en cliquant sur "OK", le fichier sera supprimé de manière définitive et ne pourra pas être récupéré.'
      : 'Warning: by clicking "OK", the file will be permanently deleted and cannot be recovered.';

    if (confirm(confirmationMessage)) {
      fetch(window.location.origin + '/api/file/remove/', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          modelName: this.$fileRemoveBtn.dataset.modelName,
          modelId: this.$fileRemoveBtn.dataset.modelId,
          fileType: this.$fileRemoveBtn.dataset.fileType,
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.removed) {
          if (this.$imagePreviewContainer) {
            this.$imagePreviewContainer.remove();
          }

          if (this.$fileRemoveBtn) {
            this.$fileRemoveBtn.remove();
          }

          if (document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr') {
            Alert.success('Le fichier a été définitivement supprimé.');
          } else {
            Alert.success('The file has been permanently deleted.');
          }
        } else {
          if (document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr') {
            Alert.error('Une erreur est survenue lors de la suppression définitive du fichier.');
          } else {
            Alert.error('An error occurred while permanently deleting the file.');
          }
        }
      })
      .catch(error => {
        if (localStorage.getItem('isDevMode') === '1') {
          console.error('Error:', error);
        }
      })
    }
  }
}
